<div class="reportDiv">
  <div style="display: flex; justify-content: end; margin-bottom: 20px">
    <button mat-raised-button color="primary" (click)="downloadPdf()">
      {{ 'Generic.download' | translate }}
    </button>
  </div>
  <div *ngIf="viewHTML" [innerHTML]="viewHTML"></div>
</div>
